"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserBalanceAsync = exports.getAssociatedMasterDealer = exports.useCarousel = exports.useMedia = exports.splitMasterDealerId = exports.getChannelNameFromLetter = exports.getChannelSelectItems = exports.getMasterDealerIds = exports.getChannelOptions = exports.getMasterDealerChannels = exports.getAssociatedMasterDealerChannels = exports.getChannels = exports.canSeeShopByCategory = exports.canSeeCoop = exports.getMasterDealerId = void 0;
var tslib_1 = require("tslib");
var axios_1 = (0, tslib_1.__importDefault)(require("axios"));
var interfaces_1 = require("@monorepo/interfaces");
var utils_1 = require("../utils");
var __1 = require("..");
var keycloak_1 = require("../infra/keycloak");
var getAuthorizedConfig = function (config) {
    var _a;
    if (config === void 0) { config = {}; }
    var token = __1.KeycloakHelper.getToken(keycloak_1.keycloakClient);
    if (!token) {
        console.log('[ChannelHelper] Authorization header missing');
        return config;
    }
    var headers = (0, tslib_1.__assign)((0, tslib_1.__assign)({}, ((_a = config.headers) !== null && _a !== void 0 ? _a : {})), { Authorization: "Bearer ".concat(token) });
    console.log('[ChannelHelper] Authorization header', headers.Authorization);
    return (0, tslib_1.__assign)((0, tslib_1.__assign)({}, config), { headers: headers });
};
var getMasterDealerId = function (masterDealerId, channel) {
    if (masterDealerId === null || channel === null)
        return '';
    return "".concat(masterDealerId).concat(channel === null || channel === void 0 ? void 0 : channel.charAt(0));
};
exports.getMasterDealerId = getMasterDealerId;
var canSeeCoop = function (masterDealerId, channel, isDealerAdmin) {
    if (isDealerAdmin === void 0) { isDealerAdmin = false; }
    return (isDealerAdmin &&
        !!masterDealerId &&
        !!channel &&
        (masterDealerId !== '2252' ||
            (masterDealerId === '2252' && isDealerAdmin)) &&
        (masterDealerId !== '3550' ||
            (masterDealerId === '3550' && isDealerAdmin)) &&
        (masterDealerId !== '2251' ||
            (masterDealerId === '2251' && isDealerAdmin)) &&
        masterDealerId !== '9999999999' &&
        masterDealerId !== '9999999998' &&
        masterDealerId !== '9999999997' &&
        masterDealerId !== '9999999996' &&
        channel !== 'NR' &&
        channel !== 'ISP');
};
exports.canSeeCoop = canSeeCoop;
var canSeeShopByCategory = function (channel) {
    return channel !== 'ISP';
};
exports.canSeeShopByCategory = canSeeShopByCategory;
var getChannels = function (associatedMasterDealers, masterDealerId) {
    var associatedMasterDealerChannels = (0, exports.getAssociatedMasterDealerChannels)(associatedMasterDealers, masterDealerId);
    return (0, utils_1.isNonEmptyArray)(associatedMasterDealerChannels)
        ? associatedMasterDealerChannels
        : (0, exports.getMasterDealerChannels)(associatedMasterDealers, masterDealerId);
};
exports.getChannels = getChannels;
var getAssociatedMasterDealerChannels = function (associatedMasterDealers, masterDealerId) {
    var _a;
    return Array.isArray(associatedMasterDealers)
        ? (0, utils_1.isNonEmptyString)(masterDealerId)
            ? ((_a = associatedMasterDealers
                .find(function (item) { return (0, utils_1.isStringEqualCI)(item.masterDealerId, masterDealerId); })) === null || _a === void 0 ? void 0 : _a.channels.filter(function (item) { return (0, utils_1.isNonEmptyString)(item); })) || []
            : Array.from(new Set(associatedMasterDealers.reduce(function (channels, associatedMasterDealer) {
                if (Array.isArray(associatedMasterDealer === null || associatedMasterDealer === void 0 ? void 0 : associatedMasterDealer.channels)) {
                    return (0, tslib_1.__spreadArray)((0, tslib_1.__spreadArray)([], channels, true), associatedMasterDealer.channels.filter(function (item) { return !!item; }), true);
                }
                else {
                    return channels;
                }
            }, [])))
        : [];
};
exports.getAssociatedMasterDealerChannels = getAssociatedMasterDealerChannels;
var getMasterDealerChannels = function (associatedMasterDealers, masterDealerId) {
    var _a, _b, _c;
    return Array.isArray(associatedMasterDealers)
        ? (0, utils_1.isNonEmptyString)(masterDealerId)
            ? ((_c = (_b = (_a = associatedMasterDealers
                .find(function (item) { return (0, utils_1.isStringEqualCI)(item.masterDealerId, masterDealerId); })) === null || _a === void 0 ? void 0 : _a.masterDealer) === null || _b === void 0 ? void 0 : _b.find(function (item) {
                return (0, utils_1.isStringEqualCI)(item.masterDealerId, masterDealerId);
            })) === null || _c === void 0 ? void 0 : _c.channels.filter(function (item) { return (0, utils_1.isNonEmptyString)(item); })) || []
            : Array.from(new Set(associatedMasterDealers.reduce(function (channels, associatedMasterDealer) {
                if (Array.isArray(associatedMasterDealer === null || associatedMasterDealer === void 0 ? void 0 : associatedMasterDealer.masterDealer)) {
                    return (0, tslib_1.__spreadArray)((0, tslib_1.__spreadArray)([], channels, true), associatedMasterDealer.masterDealer.reduce(function (_channels_, masterDealer) {
                        if (Array.isArray(masterDealer === null || masterDealer === void 0 ? void 0 : masterDealer.channels)) {
                            return (0, tslib_1.__spreadArray)((0, tslib_1.__spreadArray)([], _channels_, true), masterDealer.channels.filter(function (item) { return !!item; }), true);
                        }
                        else {
                            return _channels_;
                        }
                    }, []), true);
                }
                else {
                    return channels;
                }
            }, [])))
        : [];
};
exports.getMasterDealerChannels = getMasterDealerChannels;
var getChannelOptions = function () {
    return Object.keys(interfaces_1.DealerChannel).map(function (key) { return ({
        value: interfaces_1.DealerChannel[key],
        label: key,
    }); });
};
exports.getChannelOptions = getChannelOptions;
var getMasterDealerIds = function (associatedMasterDealers) {
    return Array.isArray(associatedMasterDealers)
        ? Array.from(new Set(associatedMasterDealers.reduce(function (ids, associatedMasterDealer) {
            var _a;
            if ((0, utils_1.isNonEmptyString)(associatedMasterDealer === null || associatedMasterDealer === void 0 ? void 0 : associatedMasterDealer.masterDealerId)) {
                ids.push((_a = associatedMasterDealer === null || associatedMasterDealer === void 0 ? void 0 : associatedMasterDealer.masterDealerId) === null || _a === void 0 ? void 0 : _a.trim().toUpperCase());
            }
            return ids;
        }, [])))
        : [];
};
exports.getMasterDealerIds = getMasterDealerIds;
var getChannelSelectItems = function () {
    return (0, exports.getChannelOptions)().map(function (item) { return ({
        id: item.value.toLowerCase(),
        value: item.label.toUpperCase(),
    }); });
};
exports.getChannelSelectItems = getChannelSelectItems;
var getChannelNameFromLetter = function (letter) {
    switch (letter) {
        case 'L':
            return 'LSP';
        case 'M':
            return 'MDU';
        case 'D':
            return 'D2D';
        case 'I':
            return 'ISP';
        case 'E':
            return 'EM';
        case 'N':
            return 'NR';
        default:
            return 'UNK';
    }
};
exports.getChannelNameFromLetter = getChannelNameFromLetter;
var splitMasterDealerId = function (masterDealerId) {
    if (!(0, utils_1.isString)(masterDealerId) || !masterDealerId.trim()) {
        return undefined;
    }
    masterDealerId = masterDealerId.trim().toUpperCase();
    var idx = masterDealerId.length - 1;
    return idx > 0
        ? {
            masterDealerId: masterDealerId.substring(0, idx),
            channel: (0, exports.getChannelNameFromLetter)(masterDealerId.charAt(idx)),
        }
        : undefined;
};
exports.splitMasterDealerId = splitMasterDealerId;
exports.useMedia = ['LSP', 'MDU', 'D2D', 'EM'];
exports.useCarousel = ['LSP', 'MDU', 'D2D', 'EM', 'NR', 'ISP'];
var getAssociatedMasterDealer = function (associatedMasterDealers, masterDealerId) {
    return (0, utils_1.isNonEmptyArray)(associatedMasterDealers) && (0, utils_1.isNonEmptyString)(masterDealerId)
        ? associatedMasterDealers.find(function (item) {
            return (0, utils_1.isStringEqualCI)(item.masterDealerId, masterDealerId);
        })
        : undefined;
};
exports.getAssociatedMasterDealer = getAssociatedMasterDealer;
var getUserBalanceAsync = function (email, masterDealerIds, channels) { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
    var requests, i, l, masterDealerId, _i_, _l_, channel, params, responses, error_1, result, i, l, response, data;
    return (0, tslib_1.__generator)(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(0, utils_1.isNonEmptyString)(email) ||
                    (!Array.isArray(masterDealerIds) && !(0, utils_1.isNonEmptyString)(masterDealerIds)) ||
                    (!Array.isArray(channels) && !(0, utils_1.isNonEmptyString)(channels))) {
                    return [2 /*return*/, undefined];
                }
                if ((0, utils_1.isNonEmptyString)(masterDealerIds)) {
                    masterDealerIds = [masterDealerIds];
                }
                if ((0, utils_1.isNonEmptyString)(channels)) {
                    channels = [channels];
                }
                requests = [];
                for (i = 0, l = masterDealerIds.length; i < l; ++i) {
                    masterDealerId = masterDealerIds[i];
                    if (!(0, utils_1.isNonEmptyString)(masterDealerId)) {
                        continue;
                    }
                    for (_i_ = 0, _l_ = channels.length; _i_ < _l_; ++_i_) {
                        channel = channels[_i_];
                        if (!(0, utils_1.isNonEmptyString)(channel)) {
                            continue;
                        }
                        params = {
                            masterDealerId: (0, exports.getMasterDealerId)(masterDealerId, channel.trim().toUpperCase()),
                            emailAddress: email === null || email === void 0 ? void 0 : email.trim().toLowerCase(),
                        };
                        requests.push(axios_1.default.post("".concat(process.env.REACT_APP_TX_BASE_URL, "/United/Balance"), null, getAuthorizedConfig({ params: params })));
                    }
                }
                if (!requests.length) {
                    return [2 /*return*/, undefined];
                }
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, Promise.all(requests)];
            case 2:
                responses = _a.sent();
                return [3 /*break*/, 4];
            case 3:
                error_1 = _a.sent();
                console.log(error_1);
                return [2 /*return*/, undefined];
            case 4:
                if (!Array.isArray(responses)) {
                    return [2 /*return*/, undefined];
                }
                result = {};
                for (i = 0, l = responses.length; i < l; ++i) {
                    response = responses[i];
                    if (response.status !== 200 || !(0, utils_1.isObject)(response.data)) {
                        continue;
                    }
                    data = response.data;
                    result[data.MasterDealerId] = {
                        masterDealerBalance: !isNaN(data === null || data === void 0 ? void 0 : data.MasterDealerBalance) && data.MasterDealerBalance > 0
                            ? data.MasterDealerBalance
                            : 0.0,
                        availableBalance: !isNaN(data === null || data === void 0 ? void 0 : data.Balance) && data.Balance > 0 ? data.Balance : 0.0,
                        allowanceUsed: (data === null || data === void 0 ? void 0 : data.AllowanceUsed) === true,
                        allowance: !isNaN(data === null || data === void 0 ? void 0 : data.Allowance) && data.Allowance > 0 ? data.Allowance : 0.0,
                    };
                }
                return [2 /*return*/, Object.keys(result).length ? result : undefined];
        }
    });
}); };
exports.getUserBalanceAsync = getUserBalanceAsync;
